import React, { useEffect, useState } from 'react';
import styles from '../static/styles/Rewards.module.css';
import weeklyTournamentBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import { getRewardsList } from '../api/rewards';

import MessagePopup from '../components/MessagePopup';

import playstation5Img from '../static/img/Rewards/Playstation5.avif';
import asusRogStrixGoImg from '../static/img/Rewards/AsusROGStrixGoUSBCGamingHeadset.avif';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import edifierG2Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import asusTufKeyboardImg from '../static/img/Rewards/asus_keyboard.avif';
import bloodyB760Img from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB865NImg from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB865N.avif';
import asusGladiusImg from '../static/img/Rewards/AsusROGGladiusIIIP514GamingMouse.avif';
import asusKerisImg from '../static/img/Rewards/AsusROGKerisP509GamingMouse.avif';
import pubgImg from '../static/img/Rewards/pubgReward.jpg';
import fortniteImg from '../static/img/Rewards/fortniteReward.avif';
import minecraftImg from '../static/img/Rewards/mirecraft_Reward.jpg';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../api/auth';
import { jwtDecode } from 'jwt-decode';
import GameNowPopup from '../components/GameNowPopup';
import { trackRewardRedemptionAttempt } from '../utils/analytics';


const Rewards = () => {
    const [message, setMessage] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showGameNow, setShowGameNow] = useState(false);
    const [rewardsData, setRewardsData] = useState([]);
    const [loadingRewards, setLoadingRewards] = useState(true);
    const [errorRewards, setErrorRewards] = useState(null);
    const navigate = useNavigate();

    const getRewardImage = (rewardName) => {
        if (!rewardName) return '';
        const name = rewardName.toLowerCase();
        if (name.includes('playstation')) return playstation5Img;
        if (name.includes('asus rog') && name.includes('headphone')) return asusRogDeltaSCoreImg;
        if (name.includes('edifier')) return edifierG1Img;
        if (name.includes('asus') && name.includes('keyboard')) return asusTufKeyboardImg;
        if (name.includes('bloody')) return bloodyB760Img;
        if (name.includes('asus rog') && name.includes('mouse')) return asusGladiusImg;
        if (name.includes('pubg')) return pubgImg;
        if (name.includes('fortnite')) return fortniteImg;
        if (name.includes('minecraft')) return minecraftImg;
        return '';
    };

    useEffect(() => {
        document.title = "Rewards | Jazz Esl"
    }, [])

    useEffect(() => {
        const loadRewards = async () => {
            try {
                setLoadingRewards(true);
                setErrorRewards(null);
                const response = await getRewardsList();
                if (response && response.data && Array.isArray(response.data)) {
                    setRewardsData(response.data);
                } else {
                    setRewardsData([]);
                }
            } catch (err) {
                setErrorRewards(err.message || 'Failed to load rewards');
            } finally {
                setLoadingRewards(false);
            }
        };
        loadRewards();
    }, []);

    const handleRedeem = (rewardIndex) => {
        if (!isAuthenticated()) {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
            return;
        }

        const accessToken = localStorage.getItem("access_token");
        const decoded = jwtDecode(accessToken);

        if (decoded.gn) {
            if (decoded.gn === 1) {
                setShowGameNow(true);
                return;
            }
        }

        const reward = rewardsData[rewardIndex];
        if (!reward) return;

        trackRewardRedemptionAttempt(reward.name, reward.id, reward.credits);
        navigate('/redeem', { state: { reward, gtagItemName: reward.name } });
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setMessage(null);
    };


    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Rewards</h2>
            <p className={styles.subheading}>Win Gaming Accessories & Currencies</p>

            {loadingRewards && <div className={styles.loading}>Loading rewards...</div>}
            {errorRewards && <div className={styles.error}>Error: {errorRewards}</div>}

            {!loadingRewards && !errorRewards && (
                <div className={styles.cardGrid}>
                    {rewardsData.map((reward, index) => (
                        <div key={reward.id || reward.name} className={styles.cardWrapper}>
                            <div className={styles.card}>
                                <div
                                    className={styles.cardContent}
                                    style={{ backgroundImage: `url(${getRewardImage(reward.name)})` }}
                                >
                                    {!reward.name?.toLowerCase().includes('playstation') && (
                                        <span className={styles.rewardNameOverlay}>{reward.name}</span>
                                    )}
                                    <div className={styles.rewardCreditsOverlay}>
                                        <span className={styles.rewardCreditsLabel}>CREDITS<br />REQUIRED</span>
                                        <span className={styles.rewardCreditsValue}>{reward.credits ? reward.credits.toLocaleString() : 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                            <button
                                className={styles.redeemButton}
                                onClick={() => handleRedeem(index)}
                                disabled={!reward.can_redeem}
                            >
                                {reward.can_redeem ? 'Redeem' : isAuthenticated() ? 'Insufficient Coins' : 'Login Required'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
            {isPopupOpen && <MessagePopup
                isOpen={isPopupOpen}
                message={message}
                onClose={handleClosePopup}
            />}

            {showGameNow && <GameNowPopup isOpen={showGameNow} onClose={() => { setShowGameNow(false) }} />}
        </div>
    );
};

export default Rewards;